import "../../stylesheets/components/overviewMenu/overview-nav.scss";

import React from "react";

import { IconButton } from "../Elements";

type OverviewNavProps = {
  openOverviewMenu: VoidFunction;
};

function OverviewNav({ openOverviewMenu }: OverviewNavProps) {
  return (
    <div className="overview-nav">
      <IconButton
        className="overview-nav__button"
        transparent
        color="generalWhite"
        icon="pushLeft"
        onClick={openOverviewMenu}
      />
    </div>
  );
}

export default OverviewNav;
